import { mapSingleAddressData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Address/mapSingleAddress'
import {
  ELECTRICITY_METER_KEY,
  SECOND_ELECTRICITY_METER_KEY,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

export const ADDRESS_LINKED_TO_CONTRACT = 'ADDRESS_LINKED_TO_CONTRACT'

const HTTP_FORBIDDEN = 403
const SECOND_POD_INDEX = 2
const METER_KEYS = ['electricityMeter', 'electricityMeter2', 'gasMeter', 'hasElectricityMeter', 'hasGasMeter']

type SavedValues = Record<string, unknown>

interface LinkedToContractResponse {
  error?: {
    code?: string
    details?: { saved?: SavedValues } | null
  }
}

export const linkedToContractSavedValues = (
  status: number | undefined,
  responseData: LinkedToContractResponse | undefined,
): SavedValues | null => {
  if (status !== HTTP_FORBIDDEN || responseData?.error?.code !== ADDRESS_LINKED_TO_CONTRACT) {
    return null
  }

  return responseData.error.details?.saved ?? {}
}

export const savedAddressFields = (saved: SavedValues): SavedValues =>
  Object.fromEntries(Object.entries(mapSingleAddressData(saved)).filter(([key]) => !METER_KEYS.includes(key)))

export const savedMeterKey = (saved: SavedValues): string =>
  saved.podIndex === SECOND_POD_INDEX ? SECOND_ELECTRICITY_METER_KEY : ELECTRICITY_METER_KEY

export const savedMeterFields = (saved: SavedValues, meterType: string): SavedValues => {
  const meterNumber = saved.meterNumber ?? null
  const consentDate = saved.consentDate ?? null

  if (meterType === 'gas') {
    return {
      id: saved.id,
      pceNo: meterNumber,
      meterSerialNumber: saved.meterSerialNumber ?? null,
      pceEligibilityData: saved.eligibilityData ?? null,
      isValidPce: !!meterNumber,
      meterConsent: consentDate !== null,
      consentDate,
    }
  }

  return {
    id: saved.id,
    pdlNo: meterNumber,
    meterSerialNumber: saved.meterSerialNumber ?? null,
    pdlEligibilityData: saved.eligibilityData ?? null,
    oldOccupant: saved.oldOccupant ?? null,
    isValidPdl: !!meterNumber,
    enedisAuth: consentDate !== null,
    consentDate,
  }
}
